import {
    type FC
} from "react";
import type IChartStateProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    CircleAlert as AlertIcon,
    RotateCcw as RotateIcon,
    Inbox as InboxIcon,
    Lock as LockIcon
} from "lucide-react-native";
import Button from "../../../button";
import Empty from "../../../empty";

const CHART_STATE_ICONS = {
    denied: LockIcon,
    empty: InboxIcon,
    error: AlertIcon
};

const CHART_STATE_TITLES = {
    denied: "chart-denied-title",
    empty: "chart-empty-title",
    error: "chart-error-title"
} as const;

const CHART_STATE_DESCRIPTIONS = {
    denied: "chart-denied-description",
    empty: "chart-empty-description",
    error: "chart-error-description"
} as const;

const CHART_STATE_ACTIONS = {
    denied: "chart-request-access",
    empty: "chart-clear-filters",
    error: "chart-retry"
} as const;

const ChartState: FC<IChartStateProps> = ({
    customLocalize,
    actionTitle,
    customTheme,
    description,
    onAction,
    title,
    kind
}) => {
    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const isError = kind === "error";

    const StateIcon = CHART_STATE_ICONS[kind];

    const renderRetryIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => <RotateIcon
        color={customColor ?? colors.content.icon[color]}
        size={size}
    />;

    return <Empty
        type={isError ? "danger" : "neutral"}
        customTheme={customTheme}
        style={stylesheet.state}
        variant="plain"
        role="status"
        size="small"
    >
        <Empty.Header>
            <Empty.Media
                icon={({
                    customColor,
                    color,
                    size
                }) => <StateIcon
                    color={customColor ?? colors.content.icon[color]}
                    size={size}
                />}
            />
            <Empty.Title>
                {title ?? localize(CHART_STATE_TITLES[kind])}
            </Empty.Title>
            <Empty.Description>
                {description ?? localize(CHART_STATE_DESCRIPTIONS[kind])}
            </Empty.Description>
        </Empty.Header>
        {
            onAction ?
                <Empty.Content>
                    <Button
                        title={actionTitle ?? localize(CHART_STATE_ACTIONS[kind])}
                        icon={isError ? renderRetryIcon : undefined}
                        customTheme={customTheme}
                        spreadBehaviour="free"
                        onPress={onAction}
                        variant="outline"
                        type="neutral"
                        size="small"
                    />
                </Empty.Content>
            :
                null
        }
    </Empty>;
};
export default ChartState;
